module.exports = __webpack_public_path__ + "img/img1.33992cd0.jpg";